function plugin(Vue) {
  if (plugin.installed) {
    return;
  }

  !Vue.prototype.$auth &&
    Object.defineProperties(Vue.prototype, {
      $auth: {
        get() {
          const _this = this;
          return permission => {
            const permissionList = _this.$store.getters.permissions;
            return Boolean(permissionList[permission]);
          };
        }
      }
    });
}

export default plugin;
